import './Offers.css'
import Card from '../../../components/Card/Card'
import img1 from './img/products.png'
import img2 from './img/services.png'
import img3 from './img/clients.png'
import img4 from './img/partners.png'



export default function Offers({ hasProducts }) {
  return (
    <div className="offers">
      <h2>Что мы предлагаем</h2>
      <div className="cardContainer">
        {hasProducts && (
        <Card
          title="Продукты"
          img={
            img1
          }
          text="// Разработка решений для автоматизации бизнеса"
          link="/product"
        />
        )}

        <Card
          title="Услуги"
          img={
            img2
          }
          text="// Предоставляем бизнесу возможность расти"
          link="/services"
        />

        <Card
          title="Клиентам"
          img={
            img3
          }
          text="// Мы открыты в общении с клиентами"
          link="/client"
        />

        <Card
          title="Партнерам"
          img={
            img4
          }
          text="// Мы готовы сотрудничать с партнерами"
          link="/partners"
        />

      </div>
    </div>
  )
}

